import React, { useMemo } from 'react';
import { useSelector } from "react-redux";
import {
  selectApprovals,
  selectIsApprovalsLoading,
  selectNameFilter
} from '@features/holidays/store/approvalRequests.duck';
import { ApprovalState, GroupedApprovalRequest } from '@features/holidays/models/approval-requests.models';
import styled from "styled-components";
import { tablet } from '@shared/ui/atoms/MediaQueries';
import { ApprovalLine } from "./ApprovalLine";
import { ApprovedLine } from "./ApprovedLine";
import { Center } from '@shared/ui/atoms/StructuralLayout';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { useTranslation } from "react-i18next";

export function ApprovalsList(props: Props) {
  const {t} = useTranslation();
  const groupedApprovals = useSelector(selectApprovals);
  const nameFilter = useSelector(selectNameFilter);
  const loading = useSelector(selectIsApprovalsLoading);

  const filteredApprovals = useMemo(() => {
    if (!nameFilter || nameFilter.length < 2) return groupedApprovals;
    const upperCaseNameFilter = nameFilter.toUpperCase();
    return groupedApprovals.filter(ga => (ga.firstName + ' ' + ga.lastName).toUpperCase().includes(upperCaseNameFilter));
  }, [groupedApprovals, nameFilter]);

  return (
    <ApprovalsListWrapper>
      {filteredApprovals.length === 0 && !loading && <>
        {!!nameFilter ? <Center>
          <BodyRegular style={{marginTop: 48}}>{t('approvals.no-results-found')}</BodyRegular>
        </Center> : <Center>
          <BodyRegular style={{marginTop: 48}}>{t('approvals.no-approvals-found')}</BodyRegular>
        </Center>}

      </>}
      {filteredApprovals.map((ga: GroupedApprovalRequest, key: number) => <React.Fragment key={key}>
        {ga.approvalState === ApprovalState.approved ? <ApprovedLine groupedApproval={ga} /> : <ApprovalLine groupedApproval={ga} />}
      </React.Fragment>)}
    </ApprovalsListWrapper>
  )
}

interface Props {
}

const ApprovalsListWrapper = styled.div`
  margin: 16px 0 0 0;
  @media (${tablet}) {
    margin: 16px 32px 0 0;
  }
`
